import React from 'react';
import ReactDOM from 'react-dom';
import { render } from '@wordpress/element';
import App from './App';
//import ToggleMenu from './components/ToggleMenu';



// Render React app into a WordPress-compatible container.
/*document.addEventListener('DOMContentLoaded', () => {
    const root = document.createElement('div');
    root.id = 'zh-localization-base-root'; //react-api-plugin-root
    document.body.appendChild(root);

    ReactDOM.render(<App />, root);
});
// Render the App component into the DOM
render(<App />, document.getElementById('footer-bottom-localization'));*/


const element = document.querySelector('#footer-bottom-localization');
if (element) {
    ReactDOM.render(<App />, element);
} else {
    document.addEventListener('DOMContentLoaded', () => {
        const root = document.createElement('div');
        root.id = 'zh-localization-base-root'; //react-api-plugin-root
        document.body.appendChild(root);    
        ReactDOM.render(<App />, root);
    });
}